import React from 'react';
import styled from 'styled-components';

const Column = styled.div`
	height: 750px;
	color: #fff;
	padding: 60px 30px;
	position: relative;
	overflow: hidden;

	&:first-of-type {
		background-color: #10345b;    
        order: 1;
	}

	&:nth-of-type(2n) {
		background-color: #669d9e;
        order: 2;
	}

	&:nth-of-type(3n) {
		background-color: #8db6b7;
	}

	@media screen and (min-width: 640px) {
		height: 900px;
		&:first-of-type {
			border-radius: 0 5px 0 0;
			-webkit-transform: translateY(-40px);
			transform: translateY(-40px);
            order: initial;
		}

		&:nth-of-type(2n) {
			border-radius: 0 0 5px 5px;
            order: initial;
		}

		&:nth-of-type(3n) {
			border-radius: 5px 0 0 0;
			-webkit-transform: translateY(-80px);
			transform: translateY(-80px);
		}
	}
`;

const ColumnContent = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	height: 300px;

	@media screen and (min-width: 640px) {
		max-width: 400px;
	}
`;

const ColumnCategoryTotal = styled.h1`
	font-size: 85px;
`;

const ColumnCategory = styled.small`
	text-transform: uppercase;
	letter-spacing: 4px;
`;

const ColumnImage = styled.img`
	width: 100%;
	max-width: 90%;
	position: absolute;
	bottom: 0;
	left: 0;
	right: 0;
	margin: auto;
	border-radius: 5px 5px 0 0;

	@media screen and (min-width: 640px) {
		max-width: 350px;
	}
`;

const BeneficiaryColumn = ({category, total, image, desc}) => {
	return (
		<Column image={image}>
			<ColumnContent>
				<ColumnCategory>
					<b>{category}</b>
				</ColumnCategory>
				<ColumnCategoryTotal>{total.toLocaleString()}</ColumnCategoryTotal>
				<p>{desc}</p>
			</ColumnContent>
			<ColumnImage src={image} loading="lazy" alt={category} />
		</Column>
	);
};

export default BeneficiaryColumn;
